/* PRSPR verbatim Beet PDP — progressive enhancement for the design markup.
   Wires the native buy-box (plan/cadence/qty/ATC/sticky), detail tabs, FAQ tabs+accordion,
   and the UGC row. No dependency; the {% form 'product' %} still add-to-carts without JS. */
(function () {
  'use strict';
  var runtimeKey = '__prsprPdpVerbatimRuntime';
  if(window[runtimeKey]) { window[runtimeKey].scan(document); return; }
  function ready(fn){ if (document.readyState!=='loading') fn(); else document.addEventListener('DOMContentLoaded', fn); }

  function getData(root){
    var el = root.querySelector('[data-vb-pdp-data]') ||
      (root.parentNode && root.parentNode.querySelector ? root.parentNode.querySelector('[data-vb-pdp-data]') : null);
    if(!el) return null;
    try {
      var data = JSON.parse(el.textContent);
      [data.oneTime].concat(data.plans || []).forEach(function(value){
        if(!value) return;
        ['priceFormatted', 'compareAtFormatted'].forEach(function(key){
          if(value[key] === undefined || value[key] === null) return;
          value[key] = String(value[key]).replace(/<[^>]*>/g, '');
        });
      });
      return data;
    } catch(e){ return null; }
  }

  // ---- Product gallery (desktop + mobile are scoped independently) ----
  function initGallery(root){
    root.querySelectorAll('.prspr-vb').forEach(function(scope){
      var main = scope.querySelector('[data-vb-gallery-main]');
      var thumbs = Array.prototype.slice.call(scope.querySelectorAll('[data-vb-gallery-thumb]'));
      if(!main || !thumbs.length) return;
      var initialActive = thumbs.filter(function(t){ return t.getAttribute('aria-pressed') === 'true'; })[0] || thumbs[0];
      var initialInactive = thumbs.filter(function(t){ return t !== initialActive; })[0];
      var activeBorder = initialActive.style.border || '2px solid #2F241F';
      var inactiveBorder = initialInactive && initialInactive.style.border ? initialInactive.style.border : '1px solid #EDE0CC';
      function activate(btn){
        var url = btn.getAttribute('data-image-url');
        if(!url) return;
        main.src = url;
        var exactAlt = btn.getAttribute('data-image-alt');
        main.alt = exactAlt !== null
          ? exactAlt
          : (btn.getAttribute('aria-label') || 'Product image').replace(/^View /, 'Fermented Beet Root & Maca \u2014 ');
        thumbs.forEach(function(t){
          var active = t === btn;
          t.setAttribute('aria-pressed', active ? 'true' : 'false');
          t.style.border = active ? activeBorder : inactiveBorder;
        });
      }
      thumbs.forEach(function(btn){
        btn.addEventListener('click', function(){ activate(btn); });
        btn.addEventListener('keydown', function(event){
          if(event.key !== 'Enter' && event.key !== ' ') return;
          event.preventDefault();
          activate(btn);
        });
      });
    });
  }
  // ---- Buy box (one per form) ----
  function initBuy(form, data){
    if(!data || form.getAttribute('data-vb-buy-ready') === 'true') return;
    form.setAttribute('data-vb-buy-ready', 'true');
    var wrapper = form.closest('.prspr-vb') || form;
    var planInput = form.querySelector('[data-vb-selling-plan]');
    var radios = form.querySelectorAll('[data-vb-plan-radio]');
    var options = wrapper.querySelectorAll('[data-vb-option], [data-vb-plan-card="once"]');
    var cadences = wrapper.querySelectorAll('[data-vb-cadence]');
    var subPriceEls = wrapper.querySelectorAll('[data-vb-sub-price]');
    var subSavingsEls = wrapper.querySelectorAll('[data-vb-sub-savings]');
    var activePriceEls = wrapper.querySelectorAll('[data-vb-active-price]');
    var activeCompareEls = wrapper.querySelectorAll('[data-vb-active-compare]');
    var activeSavingsEls = wrapper.querySelectorAll('[data-vb-active-savings]');
    var secondaryAtcs = wrapper.querySelectorAll('[data-vb-secondary-atc]');
    var legacyAtcPrices = [];
    wrapper.querySelectorAll('[data-vb-atc-price]').forEach(function(node){
      if(node.hasAttribute('data-vb-active-price')) return;
      var source = node.textContent || '';
      var dash = source.match(/^\s*(?:\u2014|\u2013|-)\s*/);
      legacyAtcPrices.push({ node: node, prefix: dash ? dash[0] : '' });
    });
    var stickyPlan = wrapper.querySelector('[data-vb-sticky-plan]');
    var stickyPrice = wrapper.querySelector('[data-vb-sticky-price]');
    var qtyInput = form.querySelector('[data-vb-qty-input]');
    var plans = data.plans || [];
    var currentPlanId = plans.length ? String(plans[0].id) : '';
    var selection = data.defaultPlan === 'sub' && plans.length ? 'sub' : 'once';

    function findPlan(id){
      for(var i=0;i<plans.length;i++) if(String(plans[i].id) === String(id)) return plans[i];
      return plans[0] || null;
    }
    function setText(nodes, value){ nodes.forEach(function(node){ node.textContent = value; }); }
    function quantity(){ return Math.max(1, parseInt(qtyInput && qtyInput.value, 10) || 1); }
    function formatMoney(cents){
      return new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
        style: 'currency', currency: data.currency || 'USD'
      }).format((Math.max(0, Number(cents) || 0)) / 100);
    }
    function paintOption(option){
      var kind = option.getAttribute('data-vb-option') || option.getAttribute('data-vb-plan-card');
      var active = kind === selection;
      var dot = option.querySelector('[data-vb-radio]');
      option.setAttribute('aria-checked', active ? 'true' : 'false');
      option.setAttribute('data-vb-selected', active ? 'true' : 'false');
      option.style.border = active ? '2px solid #2F241F' : '1px solid #EDE0CC';
      option.style.background = active ? '#FDF7EC' : '#FFFFFF';
      if(dot) dot.style.border = active ? '6px solid #2F241F' : '2px solid #C9B49A';
    }
    function paintCadence(button, plan){
      var active = !!plan && String(button.getAttribute('data-plan-id')) === String(plan.id);
      button.setAttribute('aria-pressed', active ? 'true' : 'false');
      button.setAttribute('data-vb-selected', active ? 'true' : 'false');
      if(button.hasAttribute('data-vb-plan-card')) {
        button.style.border = active ? '2px solid #2F241F' : '1px solid #EDE0CC';
        button.style.background = active ? '#FDF7EC' : '#FFFFFF';
      } else {
        button.style.border = active ? '1.5px solid #2F241F' : '1px solid #DECBAC';
        button.style.background = active ? 'rgba(47,36,31,0.06)' : '#FFFFFF';
      }
    }
    function update(){
      var plan = selection === 'sub' ? findPlan(currentPlanId) : null;
      var value = plan || data.oneTime;
      var totalPrice = formatMoney(value.price * quantity());
      if(planInput) planInput.value = plan ? plan.id : '';
      radios.forEach(function(radio){ radio.checked = radio.value === selection; });
      setText(activePriceEls, totalPrice);
      legacyAtcPrices.forEach(function(item){ item.node.textContent = item.prefix + totalPrice; });
      activeCompareEls.forEach(function(node){
        node.textContent = value.savingsPct ? formatMoney(data.oneTime.price * quantity()) : '';
        node.hidden = !value.savingsPct;
      });
      activeSavingsEls.forEach(function(node){
        node.textContent = value.savingsPct ? 'Save ' + value.savingsPct + '%' : '';
        node.hidden = !value.savingsPct;
      });
      secondaryAtcs.forEach(function(node){ node.setAttribute('data-vb-active-plan', selection); });
      options.forEach(paintOption);
      cadences.forEach(function(button){ paintCadence(button, plan); });
      if(plan){
        setText(subPriceEls, totalPrice);
        subSavingsEls.forEach(function(node){
          node.textContent = plan.savingsPct ? 'Save ' + plan.savingsPct + '%' : '';
          node.hidden = !plan.savingsPct;
        });
        if(stickyPlan) stickyPlan.textContent = data.subscriptionTitle || 'Subscribe & Save';
        if(stickyPrice) stickyPrice.textContent = totalPrice;
      } else {
        if(stickyPlan) stickyPlan.textContent = data.oneTimeLabel || 'One-time';
        if(stickyPrice) stickyPrice.textContent = totalPrice;
      }
    }

    radios.forEach(function(radio){
      radio.addEventListener('change', function(){
        if(radio.checked){ selection = radio.value === 'sub' && plans.length ? 'sub' : 'once'; update(); }
      });
    });
    cadences.forEach(function(button){
      button.addEventListener('click', function(){
        currentPlanId = button.getAttribute('data-plan-id');
        selection = 'sub';
        update();
      });
    });
    if(qtyInput){
      qtyInput.addEventListener('input', update);
      qtyInput.addEventListener('change', update);
    }
    update();
  }
  // ---- Quantity stepper (desktop) ----
  function initQty(root){
    root.querySelectorAll('[data-vb-qty-input]').forEach(function(input){
      var wrap = input.parentNode;
      var dec = wrap.querySelector('[data-vb-qty-dec]');
      var inc = wrap.querySelector('[data-vb-qty-inc]');
      function val(){ return Math.max(1, parseInt(input.value,10)||1); }
      function announce(){
        input.dispatchEvent(new Event('input', { bubbles: true }));
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }
      if(dec) dec.addEventListener('click', function(){ input.value = Math.max(1, val()-1); announce(); });
      if(inc) inc.addEventListener('click', function(){ input.value = val()+1; announce(); });
      input.addEventListener('change', function(){ input.value = val(); });
    });
  }

  // ---- Generated bundle detail tabs ----
  function initGeneratedTabs(root){
    root.querySelectorAll('[data-vb-tablist]').forEach(function(list){
      var tabs = Array.prototype.slice.call(list.querySelectorAll('[data-vb-tab]'));
      if(!tabs.length) return;
      var scope = list.closest('.prspr-vb') || root;
      var availablePanels = Array.prototype.slice.call(scope.querySelectorAll('[data-vb-tab-panel]'));
      var panels = tabs.map(function(tab){
        var id = tab.getAttribute('aria-controls');
        return availablePanels.filter(function(panel){ return panel.id === id; })[0] || null;
      });
      if(panels.some(function(panel){ return !panel; })) return;
      var authoredDisplays = panels.map(function(panel){ return panel.style.display; });
      var initial = tabs.findIndex(function(tab){ return tab.getAttribute('aria-selected') === 'true'; });
      if(initial < 0) initial = 0;
      var activeTab = tabs[initial];
      var inactiveTab = tabs.filter(function(tab){ return tab !== activeTab; })[0];
      var activeColor = activeTab.style.color;
      var activeBorder = activeTab.style.borderBottom;
      var inactiveColor = inactiveTab ? inactiveTab.style.color : activeColor;
      var inactiveBorder = inactiveTab ? inactiveTab.style.borderBottom : '2px solid transparent';
      function activate(index, moveFocus){
        tabs.forEach(function(tab, tabIndex){
          var selected = tabIndex === index;
          tab.setAttribute('aria-selected', selected ? 'true' : 'false');
          tab.setAttribute('tabindex', selected ? '0' : '-1');
          tab.style.color = selected ? activeColor : inactiveColor;
          tab.style.borderBottom = selected ? activeBorder : inactiveBorder;
          panels[tabIndex].hidden = !selected;
          panels[tabIndex].style.display = selected ? authoredDisplays[tabIndex] : 'none';
        });
        if(moveFocus) tabs[index].focus();
      }
      tabs.forEach(function(tab, index){
        tab.addEventListener('click', function(){ activate(index, false); });
        tab.addEventListener('keydown', function(event){
          var target = index;
          if(event.key === 'Enter' || event.key === ' ') target = index;
          else if(event.key === 'ArrowRight') target = (index + 1) % tabs.length;
          else if(event.key === 'ArrowLeft') target = (index - 1 + tabs.length) % tabs.length;
          else if(event.key === 'Home') target = 0;
          else if(event.key === 'End') target = tabs.length - 1;
          else return;
          event.preventDefault();
          activate(target, true);
        });
      });
      activate(initial, false);
    });
  }

  // ---- Generated bundle FAQ accordions ----
  function initGeneratedAccordions(root){
    root.querySelectorAll('[data-vb-accordion-list]').forEach(function(list){
      var answers = Array.prototype.slice.call(list.querySelectorAll('[data-vb-accordion-answer]'));
      var toggles = Array.prototype.slice.call(list.querySelectorAll('[data-vb-accordion-toggle]'));
      var entries = toggles.map(function(toggle){
        var answerId = toggle.getAttribute('aria-controls');
        var answer = answers.filter(function(candidate){ return candidate.id === answerId; })[0] || null;
        return answer ? {
          toggle: toggle,
          answer: answer,
          icon: toggle.querySelector('[data-vb-accordion-icon]')
        } : null;
      }).filter(function(entry){ return entry; });
      function setOpen(entry, open){
        entry.toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
        entry.answer.hidden = !open;
        if(entry.icon) entry.icon.textContent = open ? '\u2212' : '+';
      }
      function toggleOpen(entry){
        var opening = entry.toggle.getAttribute('aria-expanded') !== 'true';
        if(opening){
          entries.forEach(function(other){ if(other !== entry) setOpen(other, false); });
        }
        setOpen(entry, opening);
      }
      var initialOpenSeen = false;
      entries.forEach(function(entry){
        var initiallyOpen = !initialOpenSeen && entry.toggle.getAttribute('aria-expanded') === 'true';
        if(initiallyOpen) initialOpenSeen = true;
        entry.toggle.addEventListener('click', function(){ toggleOpen(entry); });
        entry.toggle.addEventListener('keydown', function(event){
          if(event.key !== 'Enter' && event.key !== ' ') return;
          event.preventDefault();
          toggleOpen(entry);
        });
        setOpen(entry, initiallyOpen);
      });
    });
  }

  // ---- Detail tabs: tablist(aria-label="Product details") -> next sibling holds the panels ----
  function initDetailTabs(root){
    root.querySelectorAll('[role="tablist"][aria-label="Product details"]').forEach(function(list){
      var tabs = Array.prototype.slice.call(list.querySelectorAll('[role="tab"]'));
      var panelWrap = list.parentNode.querySelector('div[style*="padding-top: 16px"], div[style*="padding-top: 14px"]');
      if(!panelWrap) panelWrap = list.nextElementSibling;
      if(!panelWrap) return;
      var panels = Array.prototype.filter.call(panelWrap.children, function(c){ return c.tagName === 'DIV'; });
      if(tabs.length !== panels.length) { /* still wire by min length */ }
      function activate(i){
        tabs.forEach(function(t,ti){
          var on = ti===i;
          t.setAttribute('aria-selected', on?'true':'false');
          t.style.color = on ? '#2F241F' : '#8A7A66';
          t.style.borderBottom = on ? '2px solid #9C5B2B' : '2px solid transparent';
        });
        panels.forEach(function(p,pi){ p.style.display = pi===i ? '' : 'none'; });
      }
      tabs.forEach(function(t,i){ t.addEventListener('click', function(){ activate(i); }); });
      activate(0);
    });
  }

  // ---- FAQ: category tabs + accordion ----
  function initFaq(root){
    root.querySelectorAll('[data-vb-faq-list]').forEach(function(list){
      // find the tablist that precedes this list (walk up to a common container)
      var scope = list.closest('div');
      var container = list.parentNode;
      // search whole section for the faq tab group nearest to this list
      var group = list;
      var tabWrap = null;
      var probe = list;
      for(var up=0; up<6 && probe; up++){ probe = probe.parentNode; if(probe){ var t = probe.querySelector('[data-vb-faq-tab]'); if(t){ tabWrap = probe; break; } } }
      var tabs = tabWrap ? tabWrap.querySelectorAll('[data-vb-faq-tab]') : [];
      var items = list.querySelectorAll('[data-vb-faq-item]');
      function showCat(cat){
        tabs.forEach(function(tb){
          var on = tb.getAttribute('data-cat')===cat;
          tb.setAttribute('aria-selected', on?'true':'false');
          if(on){ tb.style.border='1.5px solid #2F241F'; tb.style.background='#2F241F'; tb.style.color='#FFFAF0'; }
          else { tb.style.border='1px solid #C9B49A'; tb.style.background='transparent'; tb.style.color='#6F5546'; }
        });
        items.forEach(function(it){ it.style.display = it.getAttribute('data-cat')===cat ? '' : 'none'; });
      }
      tabs.forEach(function(tb){ tb.addEventListener('click', function(){ showCat(tb.getAttribute('data-cat')); }); });
      items.forEach(function(it){
        var btn = it.querySelector('[data-vb-faq-toggle]');
        var ans = it.querySelector('[data-vb-faq-answer]');
        var sign = it.querySelector('[data-vb-faq-sign]');
        if(!btn||!ans) return;
        btn.addEventListener('click', function(){
          var open = ans.style.display !== 'none' && ans.style.display !== '';
          // toggle
          var isOpen = ans.style.display === 'none' ? false : true;
          if(ans.style.display === 'none'){ ans.style.display=''; btn.setAttribute('aria-expanded','true'); if(sign) sign.textContent='−'; }
          else { ans.style.display='none'; btn.setAttribute('aria-expanded','false'); if(sign) sign.textContent='+'; }
        });
      });
      if(tabs.length) showCat('product');
    });
  }

  // ---- UGC row: prev/next scroll + tap to play (muted-first, one at a time) ----
  function initUgc(root){
    root.querySelectorAll('[data-ugc-wrap]').forEach(function(wrap){
      var strip = wrap.querySelector('[data-ugc-strip]');
      var btns = wrap.querySelectorAll('button[aria-label="Previous videos"], button[aria-label="Next videos"]');
      btns.forEach(function(b){
        b.addEventListener('click', function(){
          if(!strip) return;
          var dir = b.getAttribute('aria-label').indexOf('Prev')>-1 ? -1 : 1;
          strip.scrollBy({ left: dir * strip.clientWidth * 0.8, behavior:'smooth' });
        });
      });
    });
    root.querySelectorAll('[data-ugc-card]').forEach(function(card){
      var v = card.querySelector('video');
      var play = card.querySelector('[data-ugc-play]');
      var ind = card.querySelector('[data-ugc-ind]');
      var mute = card.querySelector('[data-ugc-mute]');
      if(!v) return;
      v.muted = true; try{ v.pause(); }catch(e){}
      function sync(){ if(ind) ind.style.opacity = v.paused ? '1':'0'; if(mute) mute.textContent = v.muted ? 'Muted':'Sound on'; }
      if(play) play.addEventListener('click', function(){
        if(v.paused){ document.querySelectorAll('[data-ugc-card] video').forEach(function(o){ if(o!==v) o.pause(); }); var p=v.play(); if(p&&p.catch) p.catch(function(){}); }
        else v.pause();
        setTimeout(sync,0);
      });
      if(mute) mute.addEventListener('click', function(e){ e.stopPropagation(); v.muted=!v.muted; if(!v.muted && v.paused){ var p=v.play(); if(p&&p.catch) p.catch(function(){}); } sync(); });
      v.addEventListener('play', sync); v.addEventListener('pause', sync);
      sync();
    });
  }

  function initRoot(root){
    if(root.getAttribute('data-vb-runtime-ready') === 'true') return;
    root.setAttribute('data-vb-runtime-ready', 'true');
    var data = getData(root);
    initGallery(root);
    initGeneratedTabs(root);
    initGeneratedAccordions(root);
    root.querySelectorAll('.prspr-vb-form').forEach(function(form){ initBuy(form, data); });
    initQty(root);
    initDetailTabs(root);
    initFaq(root);
    initUgc(root);
  }

  function scan(scope){
    if(scope.matches && scope.matches('[data-vb-root]')) initRoot(scope);
    scope.querySelectorAll('[data-vb-root]').forEach(initRoot);
  }

  window[runtimeKey] = { scan: scan };
  ready(function(){ scan(document); });
  document.addEventListener('shopify:section:load', function(event){ scan(event.target); });
})();
